import { useEffect } from 'react';
import { useStlVisibilityContext } from '../context/StlVisibilityContext';
import { MeshRefs } from '../types/three.types';
import * as THREE from 'three';

interface UseMeshVisibilityProps {
  meshRefs: React.MutableRefObject<MeshRefs>;
  startMeshRefs: React.MutableRefObject<THREE.Mesh[]>;
}

export const useMeshVisibility = ({
  meshRefs,
  startMeshRefs
}: UseMeshVisibilityProps) => {
  const { stlFiles } = useStlVisibilityContext();

  useEffect(() => {

    stlFiles.forEach((file, index) => {

      // Use meshIndex if available, otherwise fall back to array index
      const meshIndex = file.meshIndex !== undefined ? file.meshIndex : index;

      // Update left view meshes
      if (meshRefs.current.left[meshIndex]) {
        meshRefs.current.left[meshIndex].visible = file.isVisible;
      }

      // Update right view meshes
      if (meshRefs.current.right[meshIndex]) {
        meshRefs.current.right[meshIndex].visible = file.isVisible;
      }

      // Update start view meshes
      if (startMeshRefs.current[meshIndex]) {
        startMeshRefs.current[meshIndex].visible = file.isVisible;
      }
    });

    // Force re-render of all scenes
    if (meshRefs.current.left.length > 0) {
    }
  }, [stlFiles, meshRefs, startMeshRefs]);
};
